import { render } from "./AgeGroupCategory.vue?vue&type=template&id=391055ca&scoped=true"
import script from "./AgeGroupCategory.vue?vue&type=script&lang=js"
export * from "./AgeGroupCategory.vue?vue&type=script&lang=js"

import "./AgeGroupCategory.vue?vue&type=style&index=0&id=391055ca&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-391055ca"]])

export default __exports__